export default "__VITE_ASSET__D9cG38VX__"